function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M379.227,7.338c-9.6-9.5-25-9.8-34.9-0.7l-169.4,155.8l-34.5,31.7l-6.5,6l-81.5,55.2c-4.6,3.1-5.8,9.3-2.7,13.9 c0.2,0.4,0.5,0.7,0.8,1c-6.9,2.6-13.2,6.6-18.4,11.8c-11.6,11.6-20.5,31.1-26.5,57.9c-2.7,11.9-4.5,23.9-5.6,36 c-0.4,5.5,3.7,10.3,9.3,10.7c0.2,0,0.5,0,0.7,0s0.5,0,0.7,0c12.1-1,24.2-2.9,36-5.6c26.9-6,46.3-14.9,57.9-26.5 c5.2-5.2,9.2-11.5,11.8-18.4c1.8,1.6,4.2,2.5,6.6,2.5c0.3,0,0.6,0,1,0c3-0.3,5.7-1.9,7.3-4.4l55.1-81.5l6-6.5l187.6-203.9 C389.127,32.338,388.827,17.038,379.227,7.338z M90.527,340.438c-14.7,14.7-48.3,22.1-69.2,25c2.9-20.9,10.3-54.6,25-69.2 c5.6-5.6,13.1-8.9,21.1-9.1l32.3,32.3C99.327,327.238,96.127,334.838,90.527,340.438z M170.327,240.938l-48.7,72l-36.9-36.9 c-0.6-4.4-4.1-7.8-8.4-8.5h-0.1l-2.5-2.5l72-48.7c0.4-0.3,0.7-0.5,1.1-0.9l24.3,24.4 C170.827,240.238,170.527,240.538,170.327,240.938z M184.627,225.138l-23.2-23.2l19.9-18.2l21.6,21.6L184.627,225.138z  M365.327,28.838l-148.9,161.7l-20.4-20.4l161.7-148.8c2.1-2,5.5-1.9,7.4,0.3C367.127,23.638,367.127,26.838,365.327,28.838z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBrush = function SvgBrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 386.645 386.645",
    style: {
      enableBackground: "new 0 0 386.645 386.645"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brush.23d3f4c7.svg";
export { ForwardRef as ReactComponent };